'use client'

import moment from 'moment'
import { Link as MuiLink, Stack, Typography, Divider } from '@mui/material'
import SubscriptionSummary from './SubscriptionSummary'
import { TextBlock } from '@wolfdanepug/common-react'
import { NavLink } from 'react-router'
import { getUpcomingBillingDate } from '../../utils'

export interface SubscriptionOverviewProps {
	title?: string
	children?: any
	subscription?: any
	subscriptionModificationLinkEnabled?: boolean
	showModifyMessage?: boolean
	showIcon?: boolean
	sx?: any
	loading?: boolean
}

export default function SubscriptionOverview({
	title = 'Subsciption',
	children,
	subscription,
	subscriptionModificationLinkEnabled = true,
	showModifyMessage = true,
	showIcon = true,
	sx = {},
	loading = false
}: SubscriptionOverviewProps) {
	const upcomingBillingDate = getUpcomingBillingDate(subscription?.meta?.billingCycleStartDate)

	return (
		<Stack gap={3} sx={sx.root}>
			<SubscriptionSummary
				subscription={subscription}
				title={title}
				showIcon={showIcon}
				sx={sx.summary}
			/>

			<TextBlock
				sx={styles.dateBlock}
				title="Next Payment Date"
				text={upcomingBillingDate ? moment(upcomingBillingDate).format('MMMM Do, YYYY') : ''}
			/>

			<TextBlock
				sx={styles.dateBlock}
				title="Next Delivery Date"
				text={
					subscription?.meta?.firstDeliveryDate
						? moment(subscription?.meta?.firstDeliveryDate).format('MMMM Do, YYYY')
						: ''
				}
			/>

			{showModifyMessage && (
				<>
					<Typography variant="caption" sx={{ color: '#8B8B8B' }}>
						You can modify your subscription at any time. Modifying the serving size of the plan may
						change the subscription price.
					</Typography>

					{subscriptionModificationLinkEnabled && (
						<MuiLink fontSize={'.8rem'} component={NavLink} to="/subscription">
							Modify
						</MuiLink>
					)}
				</>
			)}

			{children && (
				<>
					<Divider sx={{ borderColor: '#E7E2EA' }} />
					{children}
				</>
			)}
		</Stack>
	)
}

const styles = {
	dateBlock: {
		title: {
			color: '#757575'
		},
		text: {
			fontSize: '22px',
			color: '#000'
		}
	}
}
